"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-casciano-in-val-di-pesa": {
    "5883014e": [{
      "hkey": "aba42f0e",
      "slug": "spedaletto-sant-andrea-in-percussina",
      "name": "Spedaletto-Sant'Andrea in Percussina",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea-in-percussina": [{
      "hkey": "aba42f0e",
      "slug": "spedaletto-sant-andrea-in-percussina",
      "name": "Spedaletto-Sant'Andrea in Percussina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "154aef70": [{
      "hkey": "aba42f0e",
      "slug": "spedaletto-sant-andrea-in-percussina",
      "name": "Spedaletto-Sant'Andrea in Percussina",
      "primary": true,
      "skipSearch": false
    }],
    "spedaletto": [{
      "hkey": "aba42f0e",
      "slug": "spedaletto-sant-andrea-in-percussina",
      "name": "Spedaletto-Sant'Andrea in Percussina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;